<template>
  <div>
    <v-icon :size="15" @click="abrirDialog">mdi-pencil</v-icon>

    <SysDialog v-model="dialog_ativo" titulo="Herança do produto" largura="675" @click:hidden-dialog="fecharDialog">
      <template v-if="etapa === 1">
        <v-radio-group v-model="heranca.tipo" class="ml-n1">
          <v-radio :value="1">
            <template #label>
              <span class="pl-1 pr-1 font-weight-medium">Lançamento</span>
              <span class="font-14"> - herda o comportamento de saídas no período de lançamento do produto.</span>
            </template>
          </v-radio>

          <v-radio :value="2">
            <template #label>
              <span class="pl-1 pr-1 font-weight-medium">Contínua</span>
              <span class="font-14"> - herda o comportamento de saídas no período atual.</span>
            </template>
          </v-radio>
        </v-radio-group>

        <SysProdutoAutocomplete
          v-if="dialog_ativo"
          v-model="heranca.idproduto"
          label="Selecione o produto do qual será herdado"
          outlined
          clearable
          :ignorar_produtos="[{ id_produto: produto.id_produto }]"
          :messages="['Produto herdado irá ficar como fora de linha.']"
          :force-busca="[heranca.idproduto]"
          incluir_produtos_combinados
        />

        <div v-if="heranca.tipo === 1 && `${heranca.idproduto || ''}`.length > 0" class="h-300px mt-n7">
          <SaidasPrimeiroSemestreProduto :produto="{grupo: produto.id_grupo, produto: heranca.idproduto}" class="ml-n4" />
        </div>
      </template>

      <MediasEProjecao
        v-if="heranca.tipo === 1 && `${heranca.idproduto || ''}`.length > 0"
        :produto="{grupo: produto.id_grupo, produto: heranca.idproduto}"
        class="px-3 mb-1"
      />

      <template v-if="etapa === 2">
        <v-switch v-model="influencia_projecao.influencia_ativada" hide-details class="ml-n1 mb-6 mt-4">
          <template #label>
            <span class="pl-1">Influênciar a projeção de vendas</span>
          </template>
        </v-switch>

        <div :class="{'mb-3': $v.influencia_projecao.data_limite.$error}">
          <v-text-field
            v-model="influencia_projecao.data_limite"
            label="Informe a data limite"
            outlined
            type="date"
            :disabled="!influencia_projecao.influencia_ativada"
            :error-messages="getMensagensValidacao($v.influencia_projecao.data_limite)"
          />
        </div>

        <div class="d-flex mt-n3">
          <div class="w-50-porcento mr-2">
            <v-select
              v-model="influencia_projecao.tipo_ajuste"
              label="Selecione o tipo de ajuste"
              :items="influencia_projecao.tipos_ajustes"
              item-value="valor"
              item-text="descricao"
              outlined
              :disabled="!influencia_projecao.influencia_ativada"
              :error-messages="getMensagensValidacao($v.influencia_projecao.tipo_ajuste)"
            />
          </div>

          <div class="w-50-porcento ml-1">
            <TextFieldFormatadorDeValor
              v-model="influencia_projecao.qtde_percentual_ajuste"
              label="Informe o percentual"
              outlined
              inteiro
              suffix="%"
              :disabled="!influencia_projecao.influencia_ativada"
              :error-messages="getMensagensValidacao($v.influencia_projecao.qtde_percentual_ajuste)"
              @focus="$event.target.select()"
            />
          </div>
        </div>
      </template>


      <template #actions>
        <v-btn v-if="heranca.tipo === 1 && etapa === 2" text @click="etapa--;influencia_projecao.influencia_ativada = false;">voltar</v-btn>

        <v-btn v-if="heranca.idproduto && heranca.tipo === 1 && etapa === 1" text color="primary" @click="etapa++">Avançar</v-btn>
        <v-btn v-else text color="primary" @click="salvarHerancaProduto">salvar</v-btn>
      </template>
    </SysDialog>
  </div>
</template>

<script>
import SysDialog from "@/components/padraoDeLayout/SysDialog";
import SysProdutoAutocomplete from "@/components/utils/crud/SysProdutoAutocomplete";
import {salvarHeranca} from "@/api/compraPorProdutosGerais/Heranca";
import {logout} from "@/helpers";
import SaidasPrimeiroSemestreProduto from "@/components/produto/detalhes/Acoes/Heranca/SaidasPrimeiroSemestreProduto";
import MediasEProjecao from "@/components/produto/detalhes/Acoes/Heranca/MediasEProjecao";
import {required} from "vuelidate/lib/validators";
import TextFieldFormatadorDeValor from "@/components/utils/TextFieldFormatadorDeValor";

export default {
  name: "Heranca",
  components: {
    TextFieldFormatadorDeValor,
    MediasEProjecao, SaidasPrimeiroSemestreProduto, SysProdutoAutocomplete, SysDialog},
  props: {
    produto: Object
  },
  data: () => ({
    dialog_ativo: false,
    etapa: 1,
    heranca: {
      idproduto: '',
      tipo: ''
    },
    influencia_projecao: {
      influencia_ativada: false,
      data_limite: '',
      qtde_percentual_ajuste: 0,
      tipo_ajuste: '',
      tipos_ajustes: [
        { valor: 'A', descricao: 'Aumento'},
        { valor: 'R', descricao: 'Redução'},
      ]
    }
  }),
  computed: {
    VALIDAR_INFLUENCIA_PROJECAO() {
      return this.heranca.tipo === 1 && this.etapa === 2 && this.influencia_projecao.influencia_ativada;
    },
    FATOR_ATUACAO_CALCULADO() {
      if (!['A', 'R'].includes(this.influencia_projecao.tipo_ajuste) || !(this.influencia_projecao.qtde_percentual_ajuste > 0)) {
        return 1;
      }

      const percentual = Number(this.influencia_projecao.qtde_percentual_ajuste) / 100.0;
      return (this.influencia_projecao.tipo_ajuste === 'A') ? percentual + 1 : 1 - percentual;
    },
  },
  validations: {
    heranca: {
      tipo: {required},
    },
    influencia_projecao: {
      data_limite: {
        required: function () {
          if (!this.VALIDAR_INFLUENCIA_PROJECAO) return true;
          return required(this.influencia_projecao.data_limite);
        },
        data_limite_valida: function () {
          if (!this.VALIDAR_INFLUENCIA_PROJECAO) return true;
          return new Date(this.influencia_projecao.data_limite) > new Date();
        },
      },
      qtde_percentual_ajuste: {
        required: function () {
          if (!this.VALIDAR_INFLUENCIA_PROJECAO) return true;
          return required(this.influencia_projecao.qtde_percentual_ajuste);
        },
        minValue: function () {
          if (!this.VALIDAR_INFLUENCIA_PROJECAO) return true;
          return Number(this.influencia_projecao.qtde_percentual_ajuste) > 0;
        }
      },
      tipo_ajuste: {
        required: function () {
          if (!this.VALIDAR_INFLUENCIA_PROJECAO) return true;
          return required(this.influencia_projecao.tipo_ajuste);
        }
      }
    },
  },
  methods: {
    getMensagensValidacao(campo) {
      if (!campo.$dirty) return [];

      if ((campo.$params.required !== undefined) && !campo.required) {
        return  ["Campo Obrigatório."];
      }

      if ((campo.$params.data_limite_valida !== undefined) && !campo.data_limite_valida) {
        return  ["Data deve ser maior que hoje."];
      }

      if ((campo.$params.minValue !== undefined) && !campo.minValue) {
        return  ["Informe um valor valido."];
      }

      return [];
    },
    abrirDialog() {
      this.dialog_ativo = ! this.dialog_ativo;

      if (this.produto.id_produto_heranca) {
        this.heranca.idproduto = this.produto.id_produto_heranca;
        this.heranca.tipo = this.produto.tipo_heranca;
      }
    },
    salvarHerancaProduto() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      const parametros = {
        grupo: this.produto.id_grupo,
        produto: this.produto.id_produto,
        produto_herdado: this.heranca.idproduto,
        tipo_heranca: this.heranca.tipo,
        influencia_ativada: this.influencia_projecao.influencia_ativada,
        influencia_projecao: {
          data_limite: this.influencia_projecao.data_limite,
          fator: this.FATOR_ATUACAO_CALCULADO,
        }
      };

      this.$store.dispatch('loading/addRequisicao',
        salvarHeranca(parametros)
          .then(() => {
            this.fecharDialog();
            this.$emit('update:heranca', {});
          })
          .catch(logout)
      );
    },
    fecharDialog() {
      this.dialog_ativo = false;
      this.etapa = 1;
      this.heranca.idproduto = '';
      this.heranca.tipo = '';

      this.influencia_projecao.influencia_ativada = false;
      this.influencia_projecao.data_limite = '';
      this.influencia_projecao.qtde_percentual_ajuste = 0;
      this.influencia_projecao.tipo_ajuste = '';
    }
  }
}
</script>

<style scoped>

</style>
